export default __webpack_public_path__ + "static/media/IntroduceYourself.04fa360a.jpg";